/*
 * @Author: your name
 * @Date: 2020-04-13 10:40:44
 * @LastEditTime: 2020-04-13 10:55:33
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \vueTest\houtai\src\main.js
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI);
Vue.config.productionTip = false

// 公共方法
import utils from './utils/utils.js'
import apis from './utils/java-https.js'
import mock from './utils/mock.js'
import config from "./utils/config.js"
import moment from 'moment' //时间插件
moment.locale('zh-cn')

import axios from "axios"
// axios.defaults.baseURL= "/api"

// 劫持 console.log/error/warn，发送到本地日志服务
const LOG_SERVER = "http://localhost:3456/log";
const origLog = console.log;
const origErr = console.error;
const origWarn = console.warn;
function sendLog(level, args) {
  try {
    const msg = args.map(a => (typeof a === "object" ? JSON.stringify(a) : String(a))).join(" ");
    fetch(LOG_SERVER, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ level, msg }) }).catch(() => {});
  } catch (e) {}
}
console.log = function(...args) { sendLog("log", args); origLog.apply(console, args); };
console.error = function(...args) { sendLog("error", args); origErr.apply(console, args); };
console.warn = function(...args) { sendLog("warn", args); origWarn.apply(console, args); };

Vue.prototype.$utils = utils;
Vue.prototype.$apis = apis;
Vue.prototype.$mock = mock;

// java文件上传接口，上传后保存到oss，黄耿智：2022-11-10
Vue.prototype.uploadUrl = config.baseUrl() + "/user-center/upload/uploadFile";
// 上传后保存在服务器本地，黄耿智：2022-11-10
Vue.prototype.uploadUrlLocal = config.baseUrl() + "/user-center/upload/server/uploadFile";
// 时间插件
Vue.prototype.$moment = moment;
// 创建全局事件
Vue.prototype.bus = new Vue();

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js